// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUnmatchedPushTotalBalanceResponse
 */
export interface IUnmatchedPushTotalBalanceResponse {
    /**
     * 
     * @type {number}
     * @memberof IUnmatchedPushTotalBalanceResponse
     */
    total_balance: number;
}

/**
 * Check if a given object implements the IUnmatchedPushTotalBalanceResponse interface.
 */
export function instanceOfIUnmatchedPushTotalBalanceResponse(value: object): value is IUnmatchedPushTotalBalanceResponse {
    if (!('total_balance' in value) || value['total_balance'] === undefined) return false;
    return true;
}

export function IUnmatchedPushTotalBalanceResponseFromJSON(json: any): IUnmatchedPushTotalBalanceResponse {
    return IUnmatchedPushTotalBalanceResponseFromJSONTyped(json, false);
}

export function IUnmatchedPushTotalBalanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUnmatchedPushTotalBalanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total_balance': json['totalBalance'],
    };
}

export function IUnmatchedPushTotalBalanceResponseToJSON(json: any): IUnmatchedPushTotalBalanceResponse {
    return IUnmatchedPushTotalBalanceResponseToJSONTyped(json, false);
}

export function IUnmatchedPushTotalBalanceResponseToJSONTyped(value?: IUnmatchedPushTotalBalanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalBalance': value['total_balance'],
    };
}

